<template>
  <div class="content" v-loading="loading">
    <el-tabs v-model="tabValue" type="card" @tab-click="handleClick">
      <el-tab-pane label="路灯策略" name="light"></el-tab-pane>
      <el-tab-pane label="集中控制策略" name="focus"></el-tab-pane>
    </el-tabs>
    <el-button
      type="primary"
      class="mw-add-button"
      @click="dialogVisible = true"
      >新建控制策略</el-button
    >
    <div v-show="tabValue==='light'">
      <el-table :data="tableData" :border="false">
        <el-table-column prop="title" label="名称"></el-table-column>
        <el-table-column label="协议">
          <template slot-scope="scope">
            <div v-if="scope.row.strategy_type==2"> 
              —
            </div>
            <div v-else>
            {{ typeArr[scope.row.type] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="策略类型">
          <template slot-scope="scope">
            {{ strategyTypeArr[scope.row.strategy_type] }}
          </template>
        </el-table-column>
        <el-table-column label="模式">
          <template slot-scope="scope">
            <div v-if="scope.row.strategy_type==2">
              —
            </div>
            <div v-else>
            {{ getValue(scope.row.is_double) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="策略分配">
          <template slot-scope="scope">
            <div v-if="scope.row.strategy_type==2">
              —
            </div>
            <div v-else>
              <i
              class="el-icon-upload2 pointer"
              @click="openSend(scope.row)"
              title="分配控制策略"
            ></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否启用">
          <template slot-scope="scope">
            <div v-if="scope.row.strategy_type==2">
              <el-switch
                v-model="scope.row.ste"
                :active-value="1"
                :inactive-value="0"
                active-color="#3ba631"
                inactive-color="#B9B9B9"
                @change="changeStates(scope.row.id,$event)"
                />
            </div>
            <div v-else>
              —
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.strategy_type==2">
              <i
                class="el-icon-s-tools pointer"
                style="font-size:16px;color:#409EFF"
                @click="openLnglat(scope.row)"
              ></i>
            </div>
            <div v-else>
              <i
                class="el-icon-edit pointer mar-r10"
                @click="(loading = true), openEdit(scope.row)"
              ></i>
              <i class="el-icon-delete pointer" @click="delItem(scope.row.id)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-show="tabValue==='focus'">
      <el-table :data="tableData" :border="true">
        <el-table-column prop="title" label="名称"></el-table-column>
        <el-table-column label="设置提前">
          <el-table-column
            prop="is_advance"
            label="是否提前"
            min-width="30">
            <template slot-scope="scope">
              {{yesOrNot[scope.row.is_advance]}}
            </template>
          </el-table-column>
          <el-table-column
            prop="is_advance_type"
            label="操作类型"
            min-width="30">
            <template slot-scope="scope">
              {{openOrClose[scope.row.is_advance_type]}}
            </template>
          </el-table-column>
          <el-table-column
            prop="advance_minute"
            label="提前时间（分钟）"
            min-width="40">
          </el-table-column>
        </el-table-column>
        <el-table-column label="设置延迟">
          <el-table-column
            prop="is_delay"
            label="是否延迟"
            min-width="30">
            <template slot-scope="scope">
              {{yesOrNot[scope.row.is_delay]}}
            </template>
          </el-table-column>
          <el-table-column
            prop="is_delay_type"
            label="操作类型"
            min-width="30">
            <template slot-scope="scope">
              {{openOrClose[scope.row.is_delay_type]}}
            </template>
          </el-table-column>
          <el-table-column
            prop="delay_minute"
            label="延迟时间（分钟）"
            min-width="40">
          </el-table-column>
        </el-table-column>
        <el-table-column label="策略分配" width="140">
          <template slot-scope="scope">
            <i
              class="el-icon-upload2 pointer"
              @click="openSend(scope.row)"
              title="分配控制策略"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="是否启用" width="140">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.ste"
              :active-value="1"
              :inactive-value="0"
              active-color="#3ba631"
              inactive-color="#B9B9B9"
              @change="changeStates(scope.row.id,$event)"
              />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <i
                class="el-icon-edit pointer mar-r10"
                @click="(loading = true), openEdit(scope.row)"
              ></i>
              <i class="el-icon-delete pointer" @click="delItem(scope.row.id)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!-- 新增控制策略 -->
    <el-dialog
      class="big-dialog"
      title="新增控制策略"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <add-strategy
        v-if="tabValue == 'light'"
        ref="addStrategy" 
        @closeMethod="closeAdd"
      ></add-strategy>
      <add-foucus-strategy
        v-else
        ref="addStrategy" 
        @closeMethod="closeAdd"
      ></add-foucus-strategy>

    </el-dialog>

    <el-dialog
      class="big-dialog"
      title="修改控制策略"
      :visible.sync="editVisible"
      v-if="editVisible"
    >
      <edit-strategy
        v-if="tabValue == 'light'"
        :editData="editData"
        ref="editStrategy"
        @closeMethod="closeEdit"
        @closeLoading="closeLoading"
      ></edit-strategy>
      <edit-foucus-strategy
        v-else
        :editData="editData"
        ref="editStrategy"
        @closeMethod="closeEdit"
        @closeLoading="closeLoading"
      ></edit-foucus-strategy>
    </el-dialog>

    <el-dialog
      class="dialog800"
      :title="'策略分配['+sendData.stg_name+']'"
      :visible.sync="sendVisible"
      v-if="sendVisible"
    >
      <send-strategy
        v-if="tabValue == 'light'"
        :sendData="sendData"
        ref="sendStrategy"
        @closeMethod="closeSend"
      ></send-strategy>
      <send-foucus-strategy
        v-else
        :sendData="sendData"
        ref="sendStrategy"
        @closeMethod="closeSend"
      ></send-foucus-strategy>
    </el-dialog>

    <el-dialog
      class="dialog600"
      title="经纬度策略调整"
      :visible.sync="lnglatVisible"
      v-if="lnglatVisible"
    >
      <lnglat-strategy
        :lnglatData="lnglatData"
        ref="lnglatStrategy"
        @closeMethod="closeLnglat"
      ></lnglat-strategy>
    </el-dialog>
  </div>
</template>
<script>
import strategyApi from "@/api/light/strategy"
import addStrategy from "@/components/light/strategy/addStrategy.vue"
import editStrategy from "@/components/light/strategy/editStrategy.vue"
import sendStrategy from "@/components/light/strategy/sendStrategy.vue"
import lnglatStrategy from "@/components/light/strategy/lnglatStrategy.vue"

import addFoucusStrategy from "@/components/light/strategy/addFoucusStrategy.vue"
import editFoucusStrategy from "@/components/light/strategy/editFoucusStrategy.vue"
import sendFoucusStrategy from "@/components/light/strategy/sendFoucusStrategy.vue"
export default {
  components: { 
    addStrategy,
    editStrategy,
    sendStrategy,
    lnglatStrategy,
    addFoucusStrategy,
    editFoucusStrategy,
    sendFoucusStrategy
  },
  data() {
    return {
      tabValue: 'light',
      yesOrNot: ['否','是'],
      openOrClose: ['关','开'],
      typeArr: ['','NB-IoT','Zigbee','LoRa','Cat.1'], // 1-4
      strategyTypeArr: ['','时控策略','经纬度策略','光照','自定义策略'], // 
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      dialogVisible: false,
      editVisible: false,
      editData: {
        id: null,
        type: 1,
        title: "",
        ste: null,
        uid: null,
        is_double: 0,
        stg: []
      },
      sendVisible: false,
      sendData: {
        stg_id: null,
        type: 1,
        stg_name: '',
        is_double: 0
      },
      lnglatVisible: false,
      lnglatData: {
        stg_id: null
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex
      this.loading = true
      this.tableData = []
      if (this.tabValue=='light') {
        strategyApi.strategyList(this.pageInfo).then((res) => {
          if (res.data.code === 1000) {
            this.loading = false;
            let resData = res.data.data;
            this.tableData = resData.list;
            this.pageInfo.page = pageIndex;
            this.cnt_all = parseInt(resData.count);
          }
        })
      }else{
        strategyApi.foucusStrategyList(this.pageInfo).then((res) => {
          if (res.data.code === 1000) {
            this.loading = false;
            let resData = res.data.data;
            this.tableData = resData.list;
            this.pageInfo.page = pageIndex;
            this.cnt_all = parseInt(resData.count);
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openSend(value) {
      let sendParams = { 
        stg_id: value.id, 
        type: value.type, 
        stg_name: value.title, 
        is_double: value.is_double
      }
      this.sendVisible = true
      this.sendData = sendParams
    },
    closeSend() {
      this.sendVisible = false
      this.sendData = {
        stg_id: null,
        type: 1,
        stg_name: '',
        is_double: 0
      }
      this.getTableData(this.pageInfo.page);
    },
    openLnglat(value) {
      let lnglatParams = { 
        stg_id: value.id
      }
      this.lnglatVisible = true
      this.lnglatData = lnglatParams
    },
    closeLnglat() {
      this.lnglatVisible = false
      this.lnglatData = {
        stg_id: null
      }
      this.getTableData(this.pageInfo.page);
    },
    closeAdd() {
      this.dialogVisible = false
      this.getTableData(this.pageInfo.page);
    },
    openEdit(strategy) {
      if(strategy.stg.length<25){
        this.editVisible = true
        this.editData = strategy
      }else{ // 防止数据量太长 浏览器加载卡死现象
        setTimeout(() => {
          this.editVisible = true
          this.editData = strategy
        }, 800)
      }
    },
    closeEdit() {
      this.editVisible = false
      this.editData = {
        id: null,
        title: "",
        type: 1,
        ste: null,
        uid: null,
        is_double: 0,
        stg: []
      }
      this.getTableData(this.pageInfo.page);
    },
    closeLoading(){
      this.loading = false
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.tabValue=='light') { 
            strategyApi.strategyDel(id).then((res) => {
              if (res.data.code === 1000) {
                this.$message.success("删除成功");
                this.getTableData(this.pageInfo.page);
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            strategyApi.foucusStrategyDel(id).then((res) => {
              if (res.data.code === 1000) {
                this.$message.success("删除成功");
                this.getTableData(this.pageInfo.page);
              } else {
                this.$message.error(res.data.message);
              }
            })
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getValue(value) {
      if (value == "1") {
        return "双灯模式";
      } else {
        return "单灯模式";
      }
    },
    changeStates(id, value) { //开关闸
      console.log('changeStates', value )
      strategyApi.airOpenControl(id,{ ste: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    handleClick() {
      console.log('tabValue', this.tabValue)
      this.getTableData(this.pageInfo.page)
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
  },
};
</script>

<style lang='less' scoped>
.new-strategy {
  display: inline-block;
  margin-top: 20px;
}
.pointer {
  cursor: pointer;
}
.lamp-refresh {
  top: -10px;
}
</style>
